import { render, staticRenderFns } from "./systemlogmanage.vue?vue&type=template&id=d53f33d8&scoped=true&"
import script from "./systemlogmanage.vue?vue&type=script&lang=js&"
export * from "./systemlogmanage.vue?vue&type=script&lang=js&"
import style0 from "./systemlogmanage.vue?vue&type=style&index=0&id=d53f33d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53f33d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d53f33d8')) {
      api.createRecord('d53f33d8', component.options)
    } else {
      api.reload('d53f33d8', component.options)
    }
    module.hot.accept("./systemlogmanage.vue?vue&type=template&id=d53f33d8&scoped=true&", function () {
      api.rerender('d53f33d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/systemlogmanage.vue"
export default component.exports